import { useState } from "react";
import { makeBEM, usernameInputValid, passwordInputValid, gracefulFinally, getDefaultFormMsg } from "../global/utils";
import { LABELS, UTILITY_CSS_CLASSES, FORM_MESSAGES } from '../global/constants';
import { loginUser, apiResultSuccess } from '../apihelper';
import FormStatus from "../atoms/FormStatus";
import FormButton from "../atoms/FormButton";

function LoginForm({ moduleName='login-form', loginSuccess }) {
    const [formStatus, setFormStatus] = useState(FORM_MESSAGES.loginFormInstructions);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [errors, setErrors] = useState({});
    const formWrapperClass = `form ${moduleName}`;
    const inputsWrapperClass = `${makeBEM('form', 'inputs-wrapper')} ${makeBEM(moduleName, 'inputs-wrapper')}`;
    const btnsDisabled = isSubmitting;

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedFormData = { ...formData, [name]: value };
        setFormData(updatedFormData);
    };

    const validateForm = () => {
        const newErrors = {};

        if ( !formData.username ) {
            newErrors.username = FORM_MESSAGES.usernameRequired;
        } else if ( !usernameInputValid(formData.username) ) {
            newErrors.username = FORM_MESSAGES.usernameInvalid;
        }

        if ( !formData.password ) {
            newErrors.password = FORM_MESSAGES.passwordRequired;
        }

        if ( formData.honeypot ) {
            newErrors.honeypot = 'I got you!';
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});

            setIsSubmitting(true);
            setFormStatus(FORM_MESSAGES.loginSubmit);
            
            try {
                loginUser(
                        (result) => {
                            if ( result.message ) {
                                setFormStatus(result.message);
                            }

                            if ( apiResultSuccess(result) ) {                        
                                loginSuccess(result);
                            }

                        }, formData
                )
            } catch(error) {
                setFormStatus(FORM_MESSAGES.failedSubmit)
            } finally {
                gracefulFinally(setIsSubmitting);
            }
        }
    };

    const getFormStatus = () => {
        for ( var prop in errors ) {
			return errors[prop];
		}

        return getDefaultFormMsg(formStatus, formStatus, FORM_MESSAGES.loginFormInstructions);
    }

    const usernameErrorClass = errors.username ? UTILITY_CSS_CLASSES.hasErrors : '';
    const passwordErrorClass = errors.password ? UTILITY_CSS_CLASSES.hasErrors : '';
    const usernameClass = `input ${makeBEM(moduleName, 'username-input')} ${usernameErrorClass}`;
    const passwordClass = `input ${makeBEM(moduleName, 'password-input')} ${passwordErrorClass}`;

    return (
        <form className={formWrapperClass} onSubmit={handleSubmit}>
            <div className={ inputsWrapperClass }>
                {/* <p 
                    className={ formStatusClass }
                >
                    { getFormStatus() }
                </p> */}
                <FormStatus
                    errors={errors}
                    formStatus= { getFormStatus() }
                    customClass={ makeBEM(moduleName, 'login-status') }
                />
                <input 
                    id="username"
                    name="username"
                    type="text" 
                    className={ usernameClass }
                    placeholder={ LABELS.username }
                    onChange={ handleChange }
                    autoComplete="on"
                    autoCapitalize="none"
                    required
                />
                <input 
                    name="password"
                    type="password" 
                    className={ passwordClass }
                    placeholder={ LABELS.password }
                    onChange={ handleChange }
                />
                <div 
                    className={ UTILITY_CSS_CLASSES.hidden } style={{ display: 'none' }}
                >
                    <label htmlFor="honeypot">Leave this field empty:</label>
                    <input 
                        name="honeypot"
                        type="text" 
                        id="honeypot"  
                        onChange={ handleChange }
                        autoComplete="off"
                    />
                </div>
                <FormButton
                    customClass={ `btn--submit ${makeBEM(moduleName, 'login-btn')}` }
                    type="submit"
                    onClick={handleSubmit}
                    disabled={btnsDisabled}
                    isSubmitting={isSubmitting}
                    icon={false}
                    buttonText={LABELS.loginBtn}
                >   
                </FormButton>
            </div>
        </form>
    )
}

export default LoginForm;